import { render, staticRenderFns } from "./DialogStatusPayment.vue?vue&type=template&id=4f78d76d"
import script from "./DialogStatusPayment.vue?vue&type=script&lang=js"
export * from "./DialogStatusPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports